<template>
    <div class="card">
        <div class="card-inner">
            <div class="card-title-group align-start mb-2">
                <div class="card-title">
                    <h6 class="title">Tickets Opened / Closed</h6>
                </div>
            </div>
            <apexchart :options="chartOptions" :series="series"></apexchart>
        </div>
    </div><!-- .card -->
</template>

<script>
export default {
    props: {
        widgetFetcher: {
            type: Object
        },
        needsRefresh: {
          type: Boolean
        }
    },
    watch : {
        needsRefresh:function() {
          this.getStats()
        }
    },
    data() {
        return {
          ticketStats: null,
          loaded: false,
          series: [],
          chartOptions: {
            colors: ['#B552CB','#1EE0AC'],
            fill: {
              colors: ['#B552CB','#1EE0AC']
            },
            dataLabels: {
              enabled: false,
              style: {
                colors: ['#B552CB','#1EE0AC']
              }
            },
            markers: {
              colors: ['#B552CB','#1EE0AC']
            },
            chart: {
              width: 200,
              height: 250,
              type: 'bar'
            },
            stroke: {
              curve: 'smooth'
            },
            xaxis: {
              categories: []
            },
            tooltip: {
              x: {
                format: 'dd/MM/yy HH:mm' + 'Of the Month'
              },
            },
          },
        }
    },
    created() {
        this.getStats()
    },
    methods:{
        getStats() {
            this.$http.post('/widgets/Get_TicketsOpenedClosedByUsersChart/', this.widgetFetcher)
            .then((response) => {
              this.ticketStats = response.data
              response.data.splice(0,1) // bit hacky but it is duplicating the first record out of the db even tho the SP isn't doing it??!?!
              let xaxis  = [] 
              let series  = [{name: 'Opened', data: []},{name: 'Closed', data: []}]
              response.data.forEach(element => {
                xaxis.push(element.day)
                series[0].data.push(element.openedCount)
                series[1].data.push(element.closedCount)
              });
              this.chartOptions.xaxis = xaxis
              this.series = series
                this.loaded = true
            })
        }
    }
}
</script>

<style>

</style>